import { useTranslation } from 'react-i18next';

const useGlobalTranslation = (ns = 'common') => {
  const { t, i18n } = useTranslation(ns);
  const { t: g } = useTranslation('common');
  return { t, g, i18n };
};

export default useGlobalTranslation;
